module.exports = __webpack_public_path__ + "img/zhifubao.04f12e4b.png";